import React from 'react';
import SEO from '../components/Seo';
import Services from '../components/Services';
import Marquee from '../components/Marquee';

function ServicesPage() {
  // Service-specific schema
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Graphic Design Services',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Faheem Graphics'
    },
    description: 'Professional graphic design services including logo design, branding, and digital marketing materials.',
    areaServed: 'Pakistan',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Design Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Logo Design'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Branding'
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO />
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
      <Services />
      <Marquee />
    </>
  );
}

export default ServicesPage;